import { useMutation } from "@apollo/react-hooks";

import { InstructorPreferences } from "../types";
import updatePreferences from "../graph-ql/updatePreferences.graphql";

const useMutationUpdatePreferences = ({
  onCompleted,
}: {
  onCompleted: (data: {
    updateInstructorPreferences?: InstructorPreferences;
  }) => void;
}) =>
  useMutation(updatePreferences, {
    onCompleted,
  });

export default useMutationUpdatePreferences;
